
import React from 'react';
import Joi from 'joi';

import Button from '../../themed/button';
import Conditional from '../../common/conditional';
import Form from '../../common/form';

import { func, object } from 'prop-types';
import { getResultOptions } from '../../../utils/data';


interface FormState {
	data: {
        testLocation: string;
        strength: string;
        result: string;
    };
    errors: {};
    loading: boolean;
    progress: number;
};

class ConcreteHammerInspectionItemEdit extends Form {
	state = {
		data: {
			testLocation: '',
			strength: '',
			result: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema: any = {
		testLocation: Joi.string().min(3).required().label('Test Location'),
		strength: Joi.number().positive().required().label('Strength (Kg/CM2)'),
		result: Joi.string().min(3).required().label('Result'),
	};

	componentDidMount() {
		this.updateStateData();
	}

	componentDidUpdate(prevProps: { range: number[]; }, prevState: FormState) {
		if (!this.props.range) throw new Error('Range must be entered!');

		if (prevProps.range !== this.props.range) {
			this.updateStateData();
		}
	}

	static propTypes = {
		onEdit: func,
		onCancelEdit: func,
		initialInspectionItem: object,

	};

	doSubmit = (): void => {
		this.props.onEdit(this.state.data);
	};

	updateStateData = () => {
		const data: any = { testLocation: this.props.initialInspectionItem.testLocation };

		for (const rangeItem of this.props.range) {
			const label = rangeItem.toString();

			data[label] = this.props.initialInspectionItem[label];
			this.schema[label] = Joi.number().positive().required().label(label);
		};

		data.strength = this.props.initialInspectionItem.strength;
		data.result = this.props.initialInspectionItem.result;

		this.setState({ data });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h3 className="form-title">Inspected Item(s)</h3>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'testLocation',
							label: 'Test Location',
							placeholder: 'Enter Test Location',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'strength',
							label: 'Strength (Kg/CM2)',
							placeholder: 'Enter Strength (Kg/CM2)',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'result',
							label: 'Result.',
							placeholder: 'Select Result',
							options: getResultOptions(),
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					{this.props.range.map((rangeItem: number, index: number) => (
						<React.Fragment key={rangeItem}>
							<div className="col">
								{this.renderInput({
									type: 'number',
									name: rangeItem.toString(),
									label: rangeItem,
									placeholder: `Enter ${rangeItem} Value`
								})}
							</div>

							<Conditional isVisible={(index + 1) % 6 === 0}>
								<div className="w-100"></div>
							</Conditional>
						</React.Fragment>
					))}
				</div>

				<div className="d-flex justify-content-end">
                        <div className="me-4">
                            <Button
                                label='Cancel' 
                                onClick={this.props.onCancelEdit}
                                style={{ backgroundColor: 'red' }} 
                            />
                        </div>

                        {this.renderButton('Save Data Changes')}
                    </div>
			</form>
		);
	}
}

export default ConcreteHammerInspectionItemEdit;
